export const iconFontAwesomeWritingFile = (
	<i className="fa-solid fa-file"></i>
);
